// extracted by mini-css-extract-plugin
export default {"content":"primary-button_content__xVrnM","spinner":"primary-button_spinner__WqABD"};